import { FormikProps } from "formik";
import { useContext } from "react";
import { AvisConfirmButton, AvisSaveButton } from "../../buttons";
import { AvisContext } from "../../../context/AvisContext";
import { AvisButtonBox } from "..";

interface ISaveAndSubmitProps<T> {
  formikProps: FormikProps<T>;
  disabled: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  disabledSubmit?: boolean;
  showSubmit?: boolean;
}
export function SaveAndSubmit<T>(props: Readonly<ISaveAndSubmitProps<T>>) {
  const {
    formikProps,
    disabled: isSubmitting,
    setIsModalOpen,
    disabledSubmit,
    showSubmit = true,
  } = props;
  const { res } = useContext(AvisContext);

  return (
    <AvisButtonBox>
      <AvisSaveButton
        onClick={() => {
          formikProps.setFieldValue("submitReport", false);
          formikProps.submitForm();
        }}
        disabled={isSubmitting}
      />
      {showSubmit && (
        <AvisConfirmButton
          label={res("button_Submit")}
          onClick={async () => {
            const errors = await formikProps.validateForm();
            if (Object.keys(errors).length > 0) return;
            formikProps.setFieldValue("submitReport", true);
            setIsModalOpen(true);
          }}
          disabled={isSubmitting || disabledSubmit}
        />
      )}
    </AvisButtonBox>
  );
}
